import React from 'react';
import DayPicker from 'react-day-picker';
import { noop } from 'lodash';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { formatMonthTitle, formatFutureMonthTitle } from './Datepicker.utils';

const { isSameMonth } = DayPicker.DateUtils;
type Props = {
  className?: string;
  displayNextMonth?: boolean;
  fromMonth: Date;
  locale?: string;
  month?: Date;
  onNext: () => void;
  onPrevious: () => void;
  toMonth: Date; // https://react-day-picker.js.org/api/DayPicker#navbarElement
};
export const DatepickerArrow = ({
  className,
  displayNextMonth,
  fromMonth,
  locale,
  month,
  onPrevious = noop,
  onNext = noop,
  toMonth,
}: Props) => {
  const arrowClasses =
    'aspect-square bg-black hocus:bg-black-active flex h-48 items-center justify-center rounded-pill text-white touch-manipulation transition-colors duration-250 ease-in';
  return (
    <div className={className}>
      {month && !isSameMonth(month, fromMonth) ? (
        <button
          className={arrowClasses}
          data-testid="datepicker-arrow-prev"
          onClick={() => onPrevious()}
          type="button"
        >
          <Icon hasRtl name={ICONS.ARROW_LEFT} width="0.625rem" />
        </button>
      ) : (
        <div className="h-48" />
      )}
      <span className="flex-1 text-20 font-semibold capitalize">
        {formatMonthTitle(month, locale)}
      </span>

      {displayNextMonth && (
        <span className="flex-1 text-20 font-semibold capitalize">
          {formatFutureMonthTitle(month, locale)}
        </span>
      )}
      {month && !isSameMonth(month, toMonth) ? (
        <button
          className={arrowClasses}
          data-testid="datepicker-arrow-next"
          onClick={() => onNext()}
          type="button"
        >
          <Icon hasRtl name={ICONS.ARROW_RIGHT} width="0.625rem" />
        </button>
      ) : (
        <div className="h-48" />
      )}
    </div>
  );
};
